var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      on: {
        mouseover: function($event) {
          return _vm.highlightOn(_vm.proprietaire)
        },
        mouseleave: function($event) {
          return _vm.highlightOff(_vm.proprietaire)
        }
      }
    },
    [
      _vm.proprietaire.TypePersonne == 1
        ? [
            _c("strong", [
              _vm._v(
                _vm._s(_vm.proprietaire.Prenom) +
                  " " +
                  _vm._s(_vm.proprietaire.Nom)
              )
            ])
          ]
        : [
            _c("strong", [_vm._v(_vm._s(_vm.proprietaire.Denomination))]),
            _vm._v(" "),
            _vm.proprietaire.Representant
              ? [
                  _vm._v("Représenté par "),
                  _c("em", [_vm._v(_vm._s(_vm.proprietaire.Representant))])
                ]
              : _vm._e()
          ],
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c(
        "em",
        [
          _vm._v(
            "\n        " +
              _vm._s(_vm.getRegimePropriete()) +
              " \n        \n        "
          ),
          _vm.proprietaire.PourcentagePropriete
            ? [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.proprietaire.PourcentagePropriete) +
                    " %\n        "
                )
              ]
            : _vm._e()
        ],
        2
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-167e6caa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-167e6caa","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./_wwwsrc/js/ConventionServitude/Components/ResumeProprietaire.vue
// module id = 659
// module chunks = 0